import type { MantineColorsTuple } from "@mantine/core";
import chroma from "chroma-js";

export function generateStandardPalette(baseColor: string): MantineColorsTuple {
  return [
    chroma(baseColor).mix("white", 0.9).hex(),
    chroma(baseColor).mix("white", 0.75).hex(),
    chroma(baseColor).mix("white", 0.6).hex(),
    chroma(baseColor).mix("white", 0.45).hex(),
    chroma(baseColor).mix("white", 0.3).hex(),
    baseColor,
    chroma(baseColor).mix("black", 0.1).hex(),
    chroma(baseColor).mix("black", 0.25).hex(),
    chroma(baseColor).mix("black", 0.4).hex(),
    chroma(baseColor).mix("black", 0.55).hex(),
  ] as MantineColorsTuple;
}
